import useTenantFeatures from '../../hooks/useTenantFeatures';
import usePermissions from '../../hooks/usePermissions';
import usePlanControl from '../../hooks/usePlanControl';

// Who may do what with care programmes, for the BUTTONS (contract §0 "UI
// gating rules"). The server decides for real on every request; this only
// keeps a button from being drawn for somebody it would refuse.
//
//   featureOn          the hospital has `care_programmes` — and `check_sets`,
//                      which it depends on (tenant features, NOT FeatureGuard,
//                      which is the doctor-plan gate)
//   buildsOwn          a doctor: Settings → Programmes
//   managesHospital    the admin, or staff whose role has `checks.manage`
//                      (web can() is true for the admin, false for a doctor)
//   clinician          start / tick / close: the doctor or the admin
//   addsLifeEvent      the closing life event: the doctor only (the admin
//                      gets 403 LIFE_EVENT_DOCTOR_ONLY)
//   desk               the desk strip: the admin, or staff with `checks.record`
//                      (a doctor sees the full card instead)
//   planOn             a DOCTOR's plan carries `care_programmes` (owner,
//                      1 Oct 2026: refused by the server without it). A doctor
//                      without it gets no card at all — buildsOwn, clinician
//                      and addsLifeEvent all follow. Always true for everyone
//                      else; the server judges an admin acting on a doctor's
//                      programme, and the card shows its reason.
//
// Call it once per screen and pass the answer down.
export default function useProgrammeAccess() {
    const role = (typeof localStorage !== 'undefined' && localStorage.getItem('Role')) || '';
    const { has } = useTenantFeatures();
    const { can } = usePermissions();
    const planOn = usePlanControl('care_programmes');
    const tenantOn = has('care_programmes') && has('check_sets');
    const featureOn = tenantOn && planOn;
    return {
        role,
        featureOn,
        planOn,
        buildsOwn: featureOn && role === 'doctor',
        managesHospital: featureOn && (role === 'admin' || (role === 'user' && can('checks.manage'))),
        clinician: featureOn && (role === 'doctor' || role === 'admin'),
        addsLifeEvent: featureOn && role === 'doctor',
        desk: featureOn && (role === 'admin' || (role === 'user' && can('checks.record'))),
    };
}
